import React, { useEffect, useState } from "react";
import { Box, Button, TablePagination, Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import TableComponent from "./Table";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import axios from "axios";
import config from "../config.json";
import { useUser } from "../contexts/UserContext";

const TransactionHistory = () => {
	const navigate = useNavigate();

	const [rows, setRows] = useState([]);
	const [loading, setLoading] = useState(true);
	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const { userId } = useUser();

	const columns = [
		{ header: "S. No", field: "id" },
		{ header: "Plan Name", field: "plan_name" },
		{ header: "Plan ID", field: "plan_id" },
	];

	const actions = [{ icon: <OpenInNewIcon />, label: "Open" }];

	useEffect(() => {
		if (!userId) {
			handleLogout();
		}
	}, [userId, navigate]);

	const handleLogout = () => {
		localStorage.removeItem("authToken");
		localStorage.removeItem("userData");
		navigate("/login");
	};

	useEffect(() => {
		const fetchPlans = async () => {
			setLoading(true);
			try {
				const response = await axios.get(
					`${config.baseURL}middlewarePlans?user_id=${userId}`,
					{
						headers: {
							...config.headers,
						},
					}
				);
				const fetchedRows = response.data.map((plan, index) => ({
					id: index + 1,
					plan_name: plan.plan_name,
					plan_id: plan.id,
				}));
				setRows(fetchedRows);
			} catch (error) {
				console.error("Error fetching plans:", error);
			} finally {
				setLoading(false);
			}
		};

		fetchPlans();
	}, []);

	const handleOpenTransactionFlow = (row) => {
		navigate("/transaction-flow", {
			state: { plan_name: row.plan_name, plan_id: row.plan_id },
		});
	};

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const paginatedRows = rows.slice(
		page * rowsPerPage,
		page * rowsPerPage + rowsPerPage
	);

	return (
		<Box sx={{ padding: 4 }}>
			<h2>Transactions</h2>
			{loading ? (
				<p>Loading...</p>
			) : (
				<>
					<TableComponent
						rows={paginatedRows}
						columns={columns}
						actions={actions}
						onActionClick={(row, action) => handleOpenTransactionFlow(row)}
					/>
					<TablePagination
						rowsPerPageOptions={[5, 10, 15]}
						component="div"
						count={rows.length}
						rowsPerPage={rowsPerPage}
						page={page}
						onPageChange={handleChangePage}
						onRowsPerPageChange={handleChangeRowsPerPage}
					/>
				</>
			)}
			<Box sx={{ display: "flex", justifyContent: "flex-end", marginTop: 2 }}>
				<Button
					variant="contained"
					onClick={() => console.log("Back button clicked")}
					sx={{
						backgroundColor: "#FF7600",
						color: "#2c2d2d",
						"&:hover": {
							backgroundColor: "#e26a00",
						},
						fontFamily: "Roboto, sans-serif",
					}}
				>
					Back
				</Button>
			</Box>
		</Box>
	);
};

export default TransactionHistory;
